import * as messageService from "../../services/message.service";
import * as documentTypeService from '../../services/documentType.service';


const state = {
    documentTypeAll:[],
    documentTypeAllActive:[],
};

const getters = {
    gettDocumentTypeAll:state => (state.documentTypeAll),
    gettDocumentTypeAllActive:state => (state.documentTypeAllActive),
};

const actions = {
    async fetchDocumentTypeAll({ commit } ){
        try {
            const response = await documentTypeService.all();
            commit('setDocumentTypeAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDocumentTypeAllActive({ commit } ){
        try {
            const response = await  documentTypeService.allActive();
            commit('setDocumentTypeAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setDocumentTypeAll:(state, res) => (
        state.documentTypeAll =  res
    ),
    setDocumentTypeAllActive:(state, res) => (
        state.documentTypeAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}